import { WAC_TO_CPAPI_LOCALE_MAP } from '@/utils/content-queries/constants';
import { SupportedLocales } from '@/utils/localization';

type State = 'draft' | 'published';

export const getLiveComposition = async (
	queryParams: URLSearchParams,
	route: string,
	currLocale: SupportedLocales = 'en-US',
) => {
	const projectId = queryParams.get('projectId');
	const compositionId = queryParams.get('compositionId');
	const compositionState: State = (queryParams.get('compositionState') as State) ?? 'draft';
	const contentfulEnv = queryParams.get('contentfulEnv') ?? 'master';
	const contentfulState: State = (queryParams.get('contentfulState') as State) ?? 'draft';

	const locale = queryParams.get('locale') ?? WAC_TO_CPAPI_LOCALE_MAP[currLocale] ?? 'en-US';
	const pageUrl = route.startsWith('/') ? route : `/${route}`;
	const hydrate = true;

	const WAC_MANAGEMENT_API_BASE_URL = process.env['WAC_MANAGEMENT_API_BASE_URL'];
	const requestUrl = `/api/v1/uniform/composition/get?
        projectId=${projectId}&
        compositionId=${compositionId}&
        compositionState=${compositionState}&
        contentfulEnv=${contentfulEnv}&
        contentfulState=${contentfulState}&
        locale=${locale}&
        pageUrl=${pageUrl}&
        hydrate=${hydrate}`;
	const requestUrlTrimmed = requestUrl.replace(/\s+/g, '');

	const wacmanGetCompositionResponse = await fetch(
		`${WAC_MANAGEMENT_API_BASE_URL}${requestUrlTrimmed}`,
	);
	const result = await wacmanGetCompositionResponse.json();

	if (result.error) {
		console.log('Error fetching live composition:', result.error);
	}

	return result.composition;
};
